// extracted by mini-css-extract-plugin
export default {"page":"UY-z","cartModal":"VY-z","checkout":"WY-z","placeholder":"XY-z","account":"YY-z"};